/**
 * Module dependencies.
 */

import { Context, ReactNode, createContext, useContext } from 'react';
import { Options } from 'src/components/core/snackbar';

type Props = {
  removeMessage: (id: number) => void;
  showMessage: (content: ReactNode, options?: Options) => void;
};

/**
 * Export `SnackbarContext` context.
 */

export const SnackbarContext: Context<Props> = createContext({} as Props);

/**
 * Export `useSnackbar` hook.
 */

export const useSnackbar = () => useContext(SnackbarContext);
